import type { RasterProfile } from '../core/types';

const GEOGRAPHIC = new Set([4326, 4269, 4267]);

/**
 * Ground area of one sampled cell, in square metres.
 * A geographic CRS gets a cosine-latitude approximation — fine at field scale, and
 * flagged as approximate wherever it is shown.
 */
export function cellAreaM2(
  raster: RasterProfile, gridW: number, gridH: number,
): number | null {
  const bbox = raster.bbox;
  if (!bbox) return null;
  const pxW = (bbox[2]! - bbox[0]!) / gridW;
  const pxH = (bbox[3]! - bbox[1]!) / gridH;
  if (isGeographic(raster)) {
    const midLat = (bbox[1]! + bbox[3]!) / 2;
    return Math.abs(pxW * 111320 * Math.cos(midLat * Math.PI / 180)) * Math.abs(pxH * 110540);
  }
  return Math.abs(pxW * pxH);   // assumes a metre-based projection
}

export const isGeographic = (raster: RasterProfile): boolean =>
  raster.epsg != null && GEOGRAPHIC.has(raster.epsg);

export const M2_PER_HA = 1e4;
export const M2_PER_ACRE = 4046.8564224;
